export const inputSwitchPt = (globalConfig) => ({
  ...globalConfig,
  slider: ({ props }) => {
    const globalInputSwitch = globalConfig({ props });

    return {
      class: [
        ...globalInputSwitch.class,
        {
          "!bg-indigo-base !dark:bg-indigo-base":
            props.modelValue == props.trueValue,
        },
        {
          "peer-hover:bg-indigo-base dark:peer-hover:bg-indigo-base":
            props.modelValue == props.trueValue && !props.disabled,
        },
        "peer-focus-visible:ring-indigo-base dark:peer-focus-visible:ring-indigo-base",
      ],
    };
  },
});


export const autoCompletePt = () => ({
  root: {
    class: 'bg-white border border-gray-300 rounded-md'
  },
  container: {
    class: 'font-sans text-base border border-none rounded-sm leading-none flex items-center flex-wrap gap-2 m-0 list-none px-3 py-1.5 w-full min-h-[2.877rem] appearance-none text-surface-700 dark:text-white/80 placeholder:text-surface-400 dark:placeholder:text-surface-500 bg-surface-0 dark:bg-surface-900 border border-surface-300 dark:border-surface-600 hover:border-primary-500 dark:hover:border-primary-400 focus:outline-none focus:outline-offset-0 transition duration-200 ease-in-out cursor-text overflow-hidden'
  },
  panel: {
    class: 'bg-white border border-gray-300 max-h-60 overflow-auto'
  },
  token: {
      class: 'inline-flex items-center py-1.5 px-3 mr-2 rounded-[1.14rem] dark:bg-surface-700 dark:text-white/70 cursor-default bg-indigo-base text-white text-sm'
  },
});


export const selectButtonPt = () => ({
  root: {
    class: 'rounded-2xl bg-gray-300 text-sm p-1',
  },
  button: (props) => ({
    class: `${props.context.active ? 'bg-indigo-base text-white' : 'bg-gray-300 text-black'} relative leading-none inline-flex items-center align-bottom text-center px-3 py-2 transition duration-200 cursor-pointer select-none overflow-hidden rounded-2xl`,
  })
});
